import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    padding: 16,
    backgroundColor: themes.light.gray_blue[7],
  },
  summaryContainer: {
    flex: 1,
    gap: 24,
  },
  title: {
    // fontSize: 20,
    // fontWeight: 'bold',
    // marginBottom: 16,
  },
  addLossButton: {
    padding: 16,
    // backgroundColor: themes.light.brand_blue[1],
    borderRadius: 8,
    alignItems: 'center',
  },
  detailsContainer: {
    flex: 1,
    gap: 8,
  },
  detailsFormContainer: {
    flexGrow: 1,
    padding: 4,
    borderRadius: 8,
    backgroundColor: themes.light.white[1],
  },
  yearItem: {
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: themes.light.brand_blue[6],
  },
  yearText: {
    fontSize: 16,
  },
  switchButtonsContainer: {
    padding: 16,
    borderRadius: 8,
    backgroundColor: themes.light.white[1],
  },
  switchButtons: {
    flexDirection: 'row',
    width: '100%',
    gap: 4,
    // marginBottom: 3,
  },
  switchButton: {
    width: '50%',
  },
  summaryButtomContainer: {
    marginTop: 'auto',
    backgroundColor: themes.light.gray_blue[7],
  },
  detailsButtomContainer: {
    marginTop: 'auto',
    backgroundColor: themes.light.white[1],
  },
});
